import {
    PersonInsuranceObject,
} from './../../../../../../../../types/src/services/object-type/person/person-insurance.object';
import { Operator } from './../../../../../../../../data-grid/src/grid/grid-request.dto';
import { Component, computed, inject, input, output, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { TableColumn, TableColumnType } from '../../../../shared/components/kit/table/table.types';
import {
    PersonInsuranceDialogComponent,
    PersonInsuranceDialogData,
} from '../person-insurance-dialog/person-insurance-dialog.component';
import { PersonInsuranceStore } from './person-insurance.store';
import { FilterInput } from '@it2go/data-grid';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import { insuranceAbbrs } from '@libs/types/src/common/enum/insurance-abbr.enum';
import { insuranceTypeEnumOptions } from '../../../../../../../../types/src/common/enum/insurance-type.enum';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-person-insurance',
    templateUrl: './person-insurance.component.html',
    styleUrls: ['./person-insurance.component.scss'],
    providers: [PersonInsuranceStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardTableComponent,
        PrimeTemplate,
        TranslatePipe,
    ],
})
export class PersonInsuranceComponent {

    public readonly dialogService = inject(BaseDialogService);
    public readonly confirm = inject(ConfirmBuilder);
    public readonly store = inject(PersonInsuranceStore);

    public personId = input<number | null>();
    public canEdit = input<boolean>(true);

    public created = output<object>();

    protected personInsuranceTable = viewChild<TableComponent>('personInsuranceTable');

    protected insurances: any[] = [];

    protected personFilter = computed<FilterInput[][]>(() => [
        [
            {
                column: 'personId',
                operator: Operator.EQ,
                value: [String(this.personId() || 0)],
            },
        ],
    ]);

    protected insurancePrefix = 'person.insurance.';
    protected columns: TableColumn[] = [
        {
            name: 'insuranceAbbr',
            filterable: {
                type: 'select',
                selectOptions: () => insuranceAbbrs,
            },
        },
        { name: 'insuredFrom', type: TableColumnType.Date, filterable: false },
        { name: 'insuredTo', type: TableColumnType.Date, filterable: false },
        {
            name: 'insuranceType',
            filterable: {
                type: 'select',
                selectOptions: () => insuranceTypeEnumOptions,
            },
        },
    ];

    constructor() {
        this.store.onSuccess(
            () => this.personInsuranceTable()?.reload(),
            'createPersonInsurance',
            'updatePersonInsurance',
            'deletePersonInsurance',
        );
    }

    protected async editInsurance(item?: PersonInsuranceObject): Promise<void> {
        const data: PersonInsuranceDialogData = item ? {
            insurance: item,
            personId: this.personId(),
            insurances: this.insurances,
        } : {
            personId: this.personId(),
            insurances: this.insurances,
        };

        this.dialogService.open(PersonInsuranceDialogComponent, {
            maximizable: true,
            data,
        }).onClose.subscribe((insurance) => {
            if (!insurance) return;

            this.created.emit(insurance);

            this.insurances = !this.personId() ? [
                ...this.insurances,
                insurance,
            ] : [];
        });
    }

    protected deletePersonInsurance(it: { item: PersonInsuranceObject, event: any, rowIndex: number }): void {
        this.confirm.confirmDelete(
            () => {
                if (this.personId()) {
                    this.store.api.deletePersonInsurance({ id: it.item.id });
                } else {
                    this.insurances = [...this.insurances.filter((_, index) => index !== it.rowIndex)];
                }
            },
            it,
        );
    }

}
